// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__11UBH","signatureButtonsRight":"ModalSign_signatureButtonsRight__2RgVq"};